import React, { useEffect, useState } from "react";
import { PiEye, PiEyeClosedLight } from "react-icons/pi";
import { Link, useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import Loader from "../Utils/Loader"
import toast from "react-hot-toast";
import { Register } from "../Reducer/apiCall";
import { useDispatch, useSelector } from "react-redux";

const SignUp = () => {
    const { status } = useSelector((state) => state.Chat);
    const navigate = useNavigate()
    const [imagePreview, setImagePreview] = useState(null);
    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImagePreview(URL.createObjectURL(file));
            formik.setFieldValue("image", file);
        } else {
            setImagePreview(null);
            formik.setFieldValue("image", null);
        }
    };

    const validationSchema = Yup.object({
        firstName: Yup.string().required("First Name is required."),
        lastName: Yup.string().required("Last Name is required."),
        email: Yup.string().email("Invalid email address.").required("Email is required."),
        password: Yup.string().min(6, "Password must be at least 6 characters").required("Password is required."),
        confirmPassword: Yup.string().oneOf([Yup.ref("password"), null], "Passwords and Confirm Password not match")
            .required("Confirm Password is required."),
        mobile: Yup.string().required("Mobile number is required."),
        image: Yup.mixed().required("Profile image is required.")

    });
    const dispatch = useDispatch()
    const formik = useFormik({
        initialValues: {
            firstName: "",
            lastName: "",
            email: "",
            password: "",
            confirmPassword: "",
            mobile: "",
            image: null,
        },
        validationSchema,
        onSubmit: async (values) => {
            const formData = new FormData();
            formData.append('firstName', values.firstName);
            formData.append('lastName', values.lastName);
            formData.append('email', values.email);
            formData.append('password', values.password);
            formData.append('confirmPassword', values.confirmPassword);
            formData.append('mobile', values.mobile);
            formData.append('image', values.image);

            const res = await dispatch(Register(formData));
            console.log('res', res)
            if (res?.status == 200) {
                toast.success(res?.data?.message);
                navigate("/login")
            } else {
                toast.error(res?.response?.data?.message || res?.message);
            }
        }
    });

    return (
    
        <div className="flex flex-col items-center my-6 text-white min-h-[80vh]">
{status == "loading" && <Loader/>}
            <div className="p-3 w-[80%] sm:w-[60%] md:w-[50%] lg:w-[40%] min-w-72 max-w-[1000px] border border-slate-400 bg-slate-800 rounded-lg h-fit mt-5 transition-all">
                <h2 className="text-2xl underline underline-offset-8 font-semibold text-white w-full text-center mb-4">
                    Register
                </h2>
                <form
                    className="w-full flex justify-between flex-col"
                    onSubmit={formik.handleSubmit}
                >
                    <h3 className="text-xl font-semibold p-1">Enter First Name</h3>
                    <input
                        className="w-full border border-slate-700 my-3 py-4 px-8 rounded-full bg-white text-black"
                        type="text"
                        placeholder="Enter First Name"
                        name="firstName"
                        value={formik.values.firstName}
                        onChange={formik.handleChange}
                    />
                    {formik.errors.firstName && formik.touched.firstName && (
                        <span className="text-red-500 text-sm">{formik.errors.firstName}</span>
                    )}

                    <h3 className="text-xl font-semibold p-1">Enter Last Name</h3>
                    <input
                        className="w-full border border-slate-700 my-3 py-4 px-8 rounded-full bg-white text-black"
                        type="text"
                        placeholder="Enter Last Name"
                        name="lastName"
                        value={formik.values.lastName}
                        onChange={formik.handleChange}
                    />
                    {formik.errors.lastName && formik.touched.lastName && (
                        <span className="text-red-500 text-sm">{formik.errors.lastName}</span>
                    )}

                    <h3 className="text-xl font-semibold p-1">Enter Email Address</h3>
                    <input
                        className="w-full border border-slate-700 my-3 py-4 px-8 rounded-full bg-white text-black"
                        type="email"
                        placeholder="Enter Email Address"
                        name="email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                    />
                    {formik.errors.email && formik.touched.email && (
                        <span className="text-red-500 text-sm">{formik.errors.email}</span>
                    )}

                    <h3 className="text-xl font-semibold p-1">Enter Password</h3>
                    <div className="relative">
                        <input
                            className="w-full border border-slate-700 my-3 py-4 px-8 rounded-full bg-white text-black"
                            type={formik.values.isShow ? "text" : "password"}
                            placeholder="Enter Password"
                            name="password"
                            value={formik.values.password}
                            onChange={formik.handleChange}
                        />
                        <span
                            onClick={() =>
                                formik.setFieldValue("isShow", !formik.values.isShow)
                            }
                            className="cursor-pointer text-black/80 absolute right-5 top-8"
                        >
                            {formik.values.isShow ? (
                                <PiEyeClosedLight fontSize={22} />
                            ) : (
                                <PiEye fontSize={22} />
                            )}
                        </span>
                    </div>
                    {formik.errors.password && formik.touched.password && (
                        <span className="text-red-500 text-sm">{formik.errors.password}</span>
                    )}

                    <h3 className="text-xl font-semibold p-1">Enter Confirm Password</h3>
                    <div className="relative">
                        <input
                            className="w-full border border-slate-700 my-3 py-4 px-8 rounded-full bg-white text-black"
                            type={formik.values.isShowPassword ? "text" : "password"}
                            placeholder="Enter Confirm Password"
                            name="confirmPassword"
                            value={formik.values.confirmPassword}
                            onChange={formik.handleChange}
                        />
                        <span
                            onClick={() =>
                                formik.setFieldValue("isShowPassword", !formik.values.isShowPassword)
                            }
                            className="cursor-pointer text-black/80 absolute right-5 top-8"
                        >
                            {formik.values.isShowPassword ? (
                                <PiEyeClosedLight fontSize={22} />
                            ) : (
                                <PiEye fontSize={22} />
                            )}
                        </span>
                    </div>
                    {formik.errors.confirmPassword && formik.touched.confirmPassword && (
                        <span className="text-red-500 text-sm">
                            {formik.errors.confirmPassword}
                        </span>
                    )}

                    <h3 className="text-xl font-semibold my-3 p-1">Enter Mobile No</h3>
                    <PhoneInput
                        country={"in"}
                        value={formik.values.mobile}
                        onChange={(value) => formik.setFieldValue("mobile", value)}
                        inputClass="w-100 p-5 my-3 rounded-full bg-white text-black"
                    />
                    {formik.errors.mobile && formik.touched.mobile && (
                        <span className="text-red-500 text-sm">{formik.errors.mobile}</span>
                    )}

                    <h3 className="text-xl font-semibold my-3 p-1">Upload Profile Image</h3>
                    <input
                        type="file"
                        accept="image/*"
                        className="block w-[63%] my-3 cursor-pointer text-sm text-gray-500 bg-white border border-slate-700 rounded-full file:py-2 file:px-4 file:rounded-full file:border-0 file:bg-slate-700 file:text-white hover:file:bg-slate-800"
                        onChange={handleImageUpload}
                    />
                    {formik.errors.image && formik.touched.image && (
                        <span className="text-red-500 text-sm">{formik.errors.image}</span>
                    )}

                    {imagePreview && (
                        <div className="mt-4 flex justify-center">
                            <img
                                src={imagePreview}
                                alt="Uploaded"
                                className="w-24 h-24 rounded-full border-2 border-slate-400 object-cover"
                            />
                        </div>
                    )}

                    <button
                        type="submit"
                        className="disabled:opacity-50 disabled:cursor-not-allowed w-1/2 mx-auto font-semibold hover:bg-slate-800 rounded-full px-5 py-4 mt-5 text-lg border border-slate-400 text-white bg-black transition-all"
                    >
                        Register
                    </button>

                    <div className="w-full flex items-center my-3">
                        <div className="w-full h-[1px] bg-slate-600"></div>
                        <Link to="/login">
                            <div className="p-3 font-semibold text-md hover:text-white">Login</div>
                        </Link>
                        <div className="w-full h-[1px] bg-slate-600"></div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SignUp;
